import React from "react";
import { Link, useLocation } from "react-router-dom";

import { rerender } from "@redux/rerender/slice";
import { useAppDispatch, useAppSelector } from "@redux/store";
import { openAuthModal } from "@/utils/authModal/openAuthModal";
import loginIcon from "@/assets/icons/login.svg";

import styles from "./LoginIcon.module.scss";

export const LoginIcon: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { auth } = useAppSelector(state => state.authAndReg);

  const handleClickLogin = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    
    openAuthModal(dispatch);
  };

  const handleClickProfile = () => {
    const currentPath = location.pathname;
    if (
      currentPath === "/profile" ||
      currentPath === "/profile/history" ||
      currentPath === "/profile/cards" ||
      currentPath === "/profile/settings"
    ) {
      dispatch(rerender());
    }
  };

  return (
    <div className={styles.icons_auth}>
      {auth ? (
        <Link
          to="/profile"
          onClick={handleClickProfile}
          state={{ from: location.pathname }}
        >
          <img src={loginIcon} alt="login icon" />
          <span>Профиль</span>
        </Link>
      ) : (
        <a href="" onClick={handleClickLogin}>
          <img src={loginIcon} alt="login icon" />
          <span>Войти</span>
        </a>
      )}
    </div>
  );
};
